import React, {Component} from 'react';
import {Icon, Image, Card} from 'semantic-ui-react';
import './style.scss';
import PageHeader from "../../components/page-header";

export default class GetPet extends Component {

    createCard = () => {
        return (<Card>
            <div className={"pet-image"}/>
            <Card.Content>
                <Card.Header>Daniel</Card.Header>
                <Card.Meta>Pet since 2016</Card.Meta>
                <Card.Description>
                    Daniel is a nice pet. He is smart and active.
                    Lorem ipsum Lorem ipsumLorem ipsumLorem ipsum
                    Lorem ipsumLorem ipsumLorem ipsumLorem ipsum
                    Lorem ipsumLorem ipsumLorem ipsumLorem ipsum
                </Card.Description>
            </Card.Content>
            <Card.Content>
                <Card.Description>
                    <Icon name='user'/>
                    Contact: +1 229-324-1122
                </Card.Description>

                <Card.Description>
                    <Icon name='address card'/>
                    Address: San Jose, CA
                </Card.Description>
            </Card.Content>
        </Card>);
    }

    render() {
        return (
            <div>
                <PageHeader text='Available dogs' history={this.props.history}/>
                <div className={'get-pet'}>
                    {this.createCard()}
                </div>
            </div>
        );

    }
}
